import { MutableRefObject } from 'react';

export function createMutableRefObject<T>(current: T): MutableRefObject<T> {
  return {
    current
  };
}
